import {HttpInterceptorFn} from '@angular/common/http';
import {getFromStorage} from '../../helpers/session-storage.helper';
import {isRichiestaBackend} from '../../helpers/backend-url.helper';

/**
 * Aggiunge il token di accesso alle sole richieste dirette alle API del
 * backend. Verso qualunque altro indirizzo (asset, modelli HTML, servizi
 * esterni) la richiesta parte senza: il token apre i dati dello studio, e
 * consegnarlo a terzi equivarrebbe a cedere la sessione.
 */
export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getFromStorage('auth-token');

  if (!token || !isRichiestaBackend(req.url)) {
    return next(req);
  }

  return next(req.clone({
    headers: req.headers.append('Authorization', `Bearer ${token}`)
  }));
};
